import { useEffect, useState } from "react";
import { getSessionInfo, formatCountdown, type SessionInfo } from "../lib/session";

export function SessionClock() {
  const [sessions, setSessions] = useState<SessionInfo[]>(() => getSessionInfo());

  useEffect(() => {
    const id = setInterval(() => setSessions(getSessionInfo()), 60_000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-2">
      {sessions.map((s) => (
        <div
          key={s.id}
          className={`flex items-center gap-2 rounded-lg border px-3 py-1.5 text-xs font-medium ${
            s.active
              ? "border-macro-accent/40 bg-macro-accent/10 text-macro-accent"
              : s.next
                ? "border-surface-3 bg-surface-2 text-slate-300"
                : "border-surface-2 bg-surface-1 text-slate-500"
          }`}
        >
          <span className="uppercase tracking-wider">{s.label}</span>
          {s.active ? (
            <span className="text-slate-400">closes {formatCountdown(s.minutesUntilClose)}</span>
          ) : s.next ? (
            <span className="text-slate-400">in {formatCountdown(s.minutesUntilOpen)}</span>
          ) : (
            <span className="text-slate-500">closed</span>
          )}
        </div>
      ))}
    </div>
  );
}
